<template>
  <modal name="modal-address-confirmation" class="modal-address-confirmation" @close="$emit('close')">
    <template v-if="openModal">
      <p slot="header" class="modal-address-confirmation__title">
        {{ $t('Confirm your street and house data') }}
      </p>
      <div slot="content">
        <address-confirmation ref="confirmation" @address-updated="updateAddress" :current-address="currentAddress" />
        <div class="modal-address-confirmation__actions">
          <mini-button-full class="address_btn" @click.native="onConfirmAddress">
            {{ $t('Confirm') }}
          </mini-button-full>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from 'theme/components/core/Modal.vue';
import AddressConfirmation from 'theme/components/core/blocks/MyAccount/ShippingDetails/AddressMap/AddressConfirmation.vue';
import { mapState } from 'vuex';

const MiniButtonFull = () => import(/* webpackChunkName: "vsf-mini-button-full" */ 'theme/components/theme/MiniButtonFull.vue');

export default {
  name: 'AddressConfirmationModal',
  components: {
    Modal,
    MiniButtonFull,
    AddressConfirmation
  },
  props: {
    openModal: {
      type: Boolean,
      required: true,
      default: false
    },
    currentAddress: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState({
      guestAddress: (state) => state.address.guestAddress
    })
  },
  methods: {
    updateAddress (address) {
      this.$emit('addressUpdated', {
        ...this.currentAddress,
        address: {
          ...this.currentAddress.address,
          road: address.street,
          house_number: address.house
        }
      });
    },
    onConfirmAddress () {
      if (!this.$refs.confirmation) {
        return;
      }
      this.$refs.confirmation.$v.$touch()
      if (this.$refs.confirmation.$v.$invalid) {
        return;
      }

      this.$emit('selectAddress', this.currentAddress);
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-address-confirmation {
  &__title {
    margin: 0;
    color: #111;
    text-align: center;
    font-size: 2rem;
    font-weight: 600;
  }

  &__actions {
    display: flex;
    column-gap: 5%;
    padding: 0 8px;
  }
}
</style>
<!--$emit('addressUpdate')-->
